import React from 'react'
import { Translation } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import TimeInputRow from './timeInputRow.component'
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core'
import { AddCircle } from '@material-ui/icons'

const styles = () => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    paddingRight: '10px !important',
    paddingLeft: '10px !important'
  }
})

const TimeInputTable = ({
  classes,
  fields,
  control,
  removeRow,
  setValue,
  isEditJournal,
  errors,
  addExtraDateRow,
  watchRowsData,
  clearErrors
}) => {
  return (
    <Translation>
      {(t) => (
        <div>
          <div className={classes.root}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tablecell}>
                    {t('workshift.cell1')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('workshift.cell2')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('workshift.cell3')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('workshift.cell4')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('workshift.cell5')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('workshift.cell6')}
                  </TableCell>
                  <TableCell className={classes.tablecell}></TableCell>
                  <TableCell className={classes.tablecell}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <GenerateTimeInputRows
                  fields={fields}
                  control={control}
                  removeRow={removeRow}
                  setValue={setValue}
                  isEditJournal={isEditJournal}
                  errors={errors}
                  watchRowsData={watchRowsData}
                  clearErrors={clearErrors}
                />
                <TableRow>
                  <TableCell
                    className={classes.tablecell}
                    colSpan={8}
                    style={{ borderBottom: 'none', padding: 0 }}
                  >
                    <div className="pull-right">
                      <IconButton
                        component="span"
                        size="medium"
                        style={{
                          color: '#F67131'
                        }}
                        onClick={addExtraDateRow}
                      >
                        <AddCircle fontSize="large" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </div>
      )}
    </Translation>
  )
}

const GenerateTimeInputRows = ({ fields, ...rest }) => {
  return fields.map((field, index) => (
    <TimeInputRow
      key={field.id}
      index={index}
      date={`dateTimeRows.${index}.date`}
      startTime={`dateTimeRows.${index}.startTime`}
      endTime={`dateTimeRows.${index}.endTime`}
      totalHour={`dateTimeRows.${index}.totalHour`}
      amount={`dateTimeRows.${index}.amount`}
      additionalInfo={`dateTimeRows.${index}.additionalInfo`}
      totalAmount={`dateTimeRows.${index}.totalAmount`}
      rowFields={fields}
      {...rest}
    />
  ))
}

export default withStyles(styles)(TimeInputTable)
